export const COMMUNITY_SOLUTION_SUPPORT_EMAIL = 'support@mathongo.com';

export const buildCommunitySolutionSupportMailto = (userEmail, solutionId) => {
  const subject = 'Community Solution | Quizrr';
  const body = `Hi Team,

I would like to report an issue with my community solution.

Registered Email: ${userEmail || ''}
Solution ID: ${solutionId || ''}

Issue:


Thanks.`;

  return `mailto:${COMMUNITY_SOLUTION_SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
